import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from 'e1p-portals-transport-js';

export default class PolicyViewService {
    static getPolicyView(policyView, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyview'),
            'getPolicyView', [policyView], additionalHeaders);
    }
}
